import React, { useState, useEffect } from "react";  

export default function Map() {

    return (
        // <div style={{position:"absolute",width:"150px",height:"50px",marginRight:"auto",marginLeft:"auto"}}>       
           <div style={{width:"150px",height:"50px",margin:"auto",position:"absolute",top:0,bottom:0,left:0,right:0}}>
                <a style={{fontWeight: "bold"}}>Uh oh, you're lost!</a>
            </div>
        // </div>
    );
}
